import { Typography } from 'components';
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';
import { FC } from 'react';
import { cn } from 'utils/cn';
import { useContentGenerationContext } from './_context/ContentGenerationContext';

const LanguagesSelector: FC = () => {
  const t = useTranslations();
  const { generatedContent, targetLanguage, handleChangeTargetLanguage } =
    useContentGenerationContext();

  return (
    <div className="flex gap-2">
      {generatedContent.generations?.map((generation) => (
        <motion.button
          key={generation.targetLanguage}
          onClick={handleChangeTargetLanguage(generation.targetLanguage as string)}
          whileTap={{ scale: 0.95 }}
          transition={{
            type: 'spring',
            stiffness: 300,
            damping: 25,
            restDelta: 10,
            mass: 1
          }}
          className={cn(
            'flex h-7 w-max flex-row items-center gap-2 rounded-10xl pl-1 pr-2 outline-none',
            'relative h-6 transition-all',
            targetLanguage === generation.targetLanguage
              ? '!bg-primary-blue-100'
              : '!bg-primary-blue-900'
          )}
        >
          <Typography
            variant="medium4"
            className={cn(
              'ml-1 !w-fit select-none !text-xs text-white transition-all',
              targetLanguage === generation.targetLanguage ? 'text-white' : 'text-primary-blue-100'
            )}
          >
            {t(`languages.${generation.targetLanguage}` as any)}
          </Typography>
        </motion.button>
      ))}
    </div>
  );
};

export default LanguagesSelector;
